<template>
  <div>
    <list-header title="My Booking" />
    <pull-to-refresh :refreshFunction="getBookingList">
      <div v-if="filteredBookings?.length !== 0">
        <div v-for="booking in filteredBookings" :key="booking.id">
          <booking-list-item
            :name="booking?.items[0]?.product?.name"
            :date="booking?.date"
            :staffName="
              booking?.items[0]?.serviceEmployees[0]?.employee?.firstName
            "
            :staffImageURL="
              booking?.items[0]?.serviceEmployees[0]?.employee?.image
            "
            :serviceImageURL="booking?.items[0]?.product?.image"
            :duration="booking?.processingTime"
            :status="booking?.status"
            :paymentStatus="booking?.paymentStatus"
            :branchName="getBranchNameById(booking?.branch)"
            :isCwaOnlineBooking="
              isCwaOnlineBooking(
                booking?.isOnlineBooking // using Optional chaining operator, value may be boolean/null/undefined
              )
            "
            class="scss-clickable scss-click-effect"
            @click="goToReviewMyBooking(booking)"
          />
        </div>
      </div>

      <!-- Bookings Not Found Message -->
      <div v-else>
        <item-not-found message="No more bookings found." />
      </div>
    </pull-to-refresh>
  </div>
</template>

<script>
import store from "@/store";
import BookingListItem from "@/components/BookingListItem.vue";
import PullToRefresh from "@/components/PullToRefresh";
import { mapActions, mapGetters } from "vuex";
import ItemNotFound from "@/components/ItemNotFound.vue";
import listHeader from "@/components/ListHeader";
import {
  convertDateToDatabaseFormat,
  getTodaysDate,
  convertToTime,
  addMinutesToTime,
} from "@/common/helpers/DateTimeHelper";
import { getBranchNameById } from "@/common/helpers/BaseHelper";

export default {
  name: "MyBooking",
  components: {
    BookingListItem,
    ItemNotFound,
    listHeader,
    PullToRefresh,
  },
  computed: {
    filteredBookings() {
      if (this.bookings) {
        const todaysDate = getTodaysDate();

        // Filter purchase record <= todays
        return this.bookings.filter((data) =>
          convertDateToDatabaseFormat(data.date) >= todaysDate ? true : false
        );
      }

      return [];
    },
    ...mapGetters(["bookings"]),
  },
  methods: {
    formatDuration(time, processingTime) {
      return `${convertToTime(time)} - ${addMinutesToTime(
        time,
        processingTime
      )}`;
    },
    goToReviewMyBooking(bookingDetails) {
      sessionStorage.setItem("bookingDetails", JSON.stringify(bookingDetails));
      this.$router.push("/booking/review");
    },
    isCwaOnlineBooking(isOnlineBooking) { // isOnlineBooking is either boolean/null/undefined
      if (isOnlineBooking === true) {
        return true;
      }
      return false;
    },
    getBranchNameById,
    ...mapActions(["getBookingList"]),
  },
  async created() {
    store.commit("showLoading", true);
    await this.getBookingList();
    store.commit("showLoading", false);
  },
};
</script>
